// api.js — Client API per AgriLog v2.0
const API_BASE = '/api';

let _token = null;

export function setToken(t) { _token = t; localStorage.setItem('agrilog_token', t); }
export function getToken() { return _token || localStorage.getItem('agrilog_token'); }
export function clearToken() { _token = null; localStorage.removeItem('agrilog_token'); }

async function req(method, path, body) {
    const token = getToken();
    const opts = {
        method,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {})
        }
    };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(API_BASE + path, opts);
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || 'Errore di rete');
    return data;
}

// ── AUTH ─────────────────────────────────────────────────────────────────────
export const requestOtp = (email) => req('POST', '/auth/request-otp', { email });
export const verifyOtp  = (email, otp, companySlug) => req('POST', '/auth/verify-otp', { email, otp, companySlug });
export const getMe      = () => req('GET', '/auth/me');
export const getPublicCompany = (slug) => req('GET', `/companies/public/${slug}`);
export const registerCompany = (companyName, cuaa, email) => req('POST', '/register', { companyName, cuaa, email });
export const createDirectCheckout = () => req('POST', '/stripe/create-direct-checkout', {});
export const verifyStripeSession = (sessionId) => req('POST', '/stripe/verify-session', { sessionId });
export const registerPaidCompany = (sessionId, companyName, cuaa, email) => req('POST', '/register-paid-company', { sessionId, companyName, cuaa, email });

// ── COMPANY ──────────────────────────────────────────────────────────────────
export const setupCompany = (name, cuaa) => req('POST', '/company/setup', { name, cuaa });
export const getCompany   = () => req('GET', '/company');
export const updateSian   = (apiKey, cuaa, certContent, certName) =>
    req('PUT', '/company/sian', { apiKey, cuaa, certContent, certName });
export const updateSplitCampaigns = (split) => req('PUT', '/company/split-campaigns', { split });
export const updateSianDelegation = (caaPartner, sianMode, signed) =>
    req('PUT', '/company/sian-delegation', { caaPartner, sianMode, signed });

// ── OPERATORS ────────────────────────────────────────────────────────────────
export const getOperators    = () => req('GET', '/operators').then(r => r.operators || []);
export const createOperator  = (data) => req('POST', '/operators', data);
export const updateOperator  = (id, data) => req('PUT', `/operators/${id}`, data);
export const deleteOperator  = (id) => req('DELETE', `/operators/${id}`);

// ── FIELDS ───────────────────────────────────────────────────────────────────
export const getFields    = () => req('GET', '/fields').then(r => r.fields || []);
export const saveField    = (field) => req('POST', '/fields', field);
export const updateCrop   = (id, crop) => req('PATCH', `/fields/${id}/crop`, { crop });
export const deleteField  = (id) => req('DELETE', `/fields/${id}`);

// ── ACTIVITIES ───────────────────────────────────────────────────────────────
export const getActivities      = (year) => req('GET', year ? `/activities?year=${year}` : '/activities').then(r => r.activities || []);
export const getActivityYears   = () => req('GET', '/activities/years').then(r => r.years || []);
export const saveActivity       = (a) => req('POST', '/activities', a);
export const deleteActivity     = (id) => req('DELETE', `/activities/${id}`);
export const syncSian           = (id, payload) => req('POST', `/activities/${id}/sync-sian`, { payload });
export const markSianTransmitted = (id) => req('POST', `/activities/${id}/mark-sian-transmitted`);

// ── INVENTORY ────────────────────────────────────────────────────────────────
export const getInventory        = () => req('GET', '/inventory').then(r => r.inventory || []);
export const saveInventoryItem   = (item) => req('POST', '/inventory', item);
export const updateStock         = (id, stock) => req('PATCH', `/inventory/${id}/stock`, { stock });
export const deleteInventoryItem = (id) => req('DELETE', `/inventory/${id}`);

// ── CAMPAIGNS ────────────────────────────────────────────────────────────────
export const getCampaigns     = () => req('GET', '/campaigns').then(r => r.campaigns || []);
export const openCampaign     = (year, yearType, startDate, endDate) =>
    req('POST', '/campaigns', { year, yearType, startDate, endDate });
export const closeCampaign    = (year) => req('POST', `/campaigns/${year}/close`);

// ── FIELD ROTATIONS ──────────────────────────────────────────────────────────
export const getFieldRotations  = (year) => req('GET', `/field-rotations?year=${year}`).then(r => r.rotations || []);
export const saveFieldRotation  = (fieldId, year, crop, notes) =>
    req('PUT', '/field-rotations', { fieldId, year, crop, notes });

/** Oggetto api unificato (index bundle + registrati.html via import nominati) */
export const api = {
    setToken,
    getToken,
    clearToken,
    requestOtp,
    verifyOtp,
    getMe,
    getPublicCompany,
    registerCompany,
    createDirectCheckout,
    verifyStripeSession,
    registerPaidCompany,
    setupCompany,
    getCompany,
    updateSian,
    updateSplitCampaigns,
    updateSianDelegation,
    getOperators,
    createOperator,
    updateOperator,
    deleteOperator,
    getFields,
    saveField,
    updateCrop,
    deleteField,
    getActivities,
    getActivityYears,
    saveActivity,
    deleteActivity,
    syncSian,
    markSianTransmitted,
    getInventory,
    saveInventoryItem,
    updateStock,
    deleteInventoryItem,
    getCampaigns,
    openCampaign,
    closeCampaign,
    getFieldRotations,
    saveFieldRotation
};

export default api;
